import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/gaushala/animals";

export const Route = createFileRoute("/admin/_modules/_gaushala/animals")({
  component: Page,
});
